import { GetExtension } from "./GetExtension";

export function SaveLoadFileAsJSON(fileName) {
  var fileExt = GetExtension(fileName);
  return fileExt == "ocd" || fileExt == "ocb"; //TODO when we convert backgrounds to json - add this || fileExt == 'ocb');
}
